// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crZIu6NfBEMibKVywctl{flex-direction:column;align-items:center;display:flex}.NmC6NMn0V9kgAIsZtaCk{margin-bottom:20px}.EOHFpoD7XMUBQLg2srQa{cursor:pointer;border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;padding:32px 24px;position:relative}.EOHFpoD7XMUBQLg2srQa:hover{border:1px solid var(--interaction-neutral-hovered)}.VEQJPdR3p8ktHh_IDAwZ{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropZone": `crZIu6NfBEMibKVywctl`,
	"uploadIcon": `NmC6NMn0V9kgAIsZtaCk`,
	"dragAndDropContainer": `EOHFpoD7XMUBQLg2srQa`,
	"fileInput": `VEQJPdR3p8ktHh_IDAwZ`
};
export default ___CSS_LOADER_EXPORT___;
